import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Link as Link2 } from "react-router-dom";

import Logo from "../assets/images/logo-light.svg";

export default function Footer() {
  return (
    <footer className="bg-footer">
      <Container>
        <Row>
          <div className="col-12">
            <div className="footer-py-60">
              <Row>
                <div className="col-lg-6 col-12 mb-lg-0 mb-md-4 pb-lg-0 pb-md-2">
                  <Link2 to="#" className="logo-footer">
                    <img src={Logo} height="48" alt="" />
                  </Link2>
                  <p className="mt-4 mb-0">
                    It's a 'new mantra' of automation, machine learning, Al, and
                    analytics solutions. We will accelerate your organization's
                    evolution as the 'Citizen Data Scientist' community.
                  </p>
                </div>

                <div className="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <h5 className="footer-head">Policies</h5>
                  <ul className="list-unstyled footer-list mt-4">
                    <li>
                      <Link2 to="/policies?tab=privacy" className="text-foot">
                        <i className="uil uil-angle-right-b me-1"></i> Privacy
                        Policy
                      </Link2>
                    </li>
                    {/* <li>
                      <Link2 to="/policies?tab=privacy" className="text-foot">
                        <i className="uil uil-angle-right-b me-1"></i> Hipaa
                        Privacy Policy
                      </Link2>
                    </li> */}
                    <li>
                      <Link2 to="/policies?tab=cookies" className="text-foot">
                        <i className="uil uil-angle-right-b me-1"></i> Cookies
                        Policy
                      </Link2>
                    </li>
                    <li>
                      <Link2 to="/policies?tab=terms" className="text-foot">
                        <i className="uil uil-angle-right-b me-1"></i> Terms And
                        Conditions
                      </Link2>
                    </li>
                  </ul>
                </div>

                <div className="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <h5 className="footer-head">Contact</h5>
                  <ul className="list-unstyled footer-list mt-4">
                    <li>
                      <i className="uil uil-envelope me-2"></i>
                      <a
                        href="mailto:bdm@numantratech.ai"
                        className="text-foot"
                      >
                        bdm@numantratech.ai
                      </a>
                    </li>
                    <li>
                      <i className="uil uil-linkedin me-2"></i>
                      <a
                        href="https://www.linkedin.com/company/numantra-technologies-inc/"
                        className="text-foot"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Follow us on LinkedIn
                      </a>
                    </li>
                  </ul>
                </div>
              </Row>
            </div>
          </div>
        </Row>
      </Container>

      <div className="footer-py-30 footer-bar">
        <div className="container text-center">
          <Row className="align-items-center justify-content-center">
            <Col sm={8}>
              <div className="text-sm-start">
                <p className="mb-0">
                  © {new Date().getFullYear()} Numantra Technologies. All rights
                  reserved.
                </p>
                <p>Version: 2.0.1</p>
              </div>
            </Col>

            <div className="col-sm-4 mt-4 mt-sm-0">
              <ul className="list-unstyled social-icon text-sm-end foot-social-icon mb-0">
                <li className="list-inline-item ms-1">
                  <Link2
                    to="https://www.linkedin.com/company/numantra-technologies-inc/"
                    no
                    className="rounded"
                    target="_blank"
                  >
                    <i className="uil uil-linkedin" title="Linkedin"></i>
                  </Link2>
                </li>
                {/* <li className="list-inline-item ms-1">
                  <Link2 to="#" className="rounded">
                    <i
                      className="uil uil-facebook-f align-middle"
                      title="facebook"
                    ></i>
                  </Link2>
                </li> */}
                <li className="list-inline-item ms-1">
                  <Link2 to="#" className="rounded">
                    <i
                      className="uil uil-twitter align-middle"
                      title="twitter"
                    ></i>
                  </Link2>
                </li>
                <li className="list-inline-item ms-1">
                  <Link2
                    to="mailto:bdm@numantratech.ai"
                    className="rounded"
                    target="_blank"
                  >
                    <i
                      className="uil uil-envelope align-middle"
                      title="email"
                    ></i>
                  </Link2>
                </li>
              </ul>
            </div>
          </Row>
        </div>
      </div>
    </footer>
  );
}
